import { render, staticRenderFns } from "./family-apply-detail.vue?vue&type=template&id=76bb9d7e&scoped=true"
import script from "./family-apply-detail.vue?vue&type=script&lang=js"
export * from "./family-apply-detail.vue?vue&type=script&lang=js"
import style0 from "./family-apply-detail.vue?vue&type=style&index=0&id=76bb9d7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a947b4d37137bf79d4abbd1caef86e24/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bb9d7e",
  null
  
)

export default component.exports